"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnrageAbilityHandler = exports.EnrageActorAbilityFactory = exports.EnrageAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const EventType_1 = require("../../core/events/EventType");
const Schedule_1 = require("../../core/Schedule");
class EnrageAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Enrage;
        this.__typeName = "Enrage";
    }
}
exports.EnrageAbilityArgs = EnrageAbilityArgs;
let EnrageActorAbilityFactory = class EnrageActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Enrage", "Self", 0);
    }
};
EnrageActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Enrage")
], EnrageActorAbilityFactory);
exports.EnrageActorAbilityFactory = EnrageActorAbilityFactory;
let EnrageAbilityHandler = class EnrageAbilityHandler {
    init(sequence, container, actorId) {
        const healthThreshold = container.getPercentOfBaseHealth(actorId, 30);
        container.applyBuff({
            sequence,
            creatorId: actorId,
            targetId: actorId,
            duration: Duration_1.Duration.Permanent,
            effect: new core_1.LinkedEventHandlerEffectArgs("Enrage", "Increases damage when health is low", false, container.registerEventHandlerScript(actorId, EventType_1.EventType.AttributeChanged, Schedule_1.Schedule.Unlimited, "Effect_Enrage_OnHealthChange", {
                healthThreshold,
                damageIncreasePercent: 40
            })),
            supernatural: true,
        });
    }
    activate(sequence, container, ability) {
        throw new Error("PASSIVE_ONLY");
    }
};
EnrageAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Enrage)
], EnrageAbilityHandler);
exports.EnrageAbilityHandler = EnrageAbilityHandler;
